const INITIAL_STATE = {
    data: [],
    loading: false,
    error: false
};

export default function branch(state = INITIAL_STATE, action){
    switch (action.type){
        case "ADD_BRANCH":
            return { ...state, loading: true }
        case "SUCCESS_ADD_BRANCH":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_ADD_BRANCH":
            return { data: [], loading: false, error: true }
        case "REMOVE_BRANCH":
            return { ...state, loading: true }
        case "SUCCESS_REMOVE_BRANCH":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_REMOVE_BRANCH":
            return { data: [], loading: false, error: true }
        case "UPDATE_BRANCH":
            return { ...state, loading: true }
        case "SUCCESS_UPDATE_BRANCH":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_UPDATE_BRANCH":
            return { data: [], loading: false, error: true }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/branch.js